// extracted by mini-css-extract-plugin
export default {"container":"CardSummary_container__qAEUz","text":"CardSummary_text__JGBhY"};